var path = '/sessionTimeout/sessionTimeout.tpl.html';
var html = "<div></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;